import Vue from 'vue'
import { decode } from '@/lib/util'
import '../v-video/v-video.vue'
import '../picture/picture.vue'
import isEmpty from 'lodash/isEmpty'

export default el => new Vue({
  name: 'Featured Ingredient',
  el,
  data () {
    const sectionSettings = JSON.parse(decode(el.getAttribute('data-section-settings')))
    return {
      ...sectionSettings,
      breakpoints: '(max-width: 767px)|(min-width: 768px)'
    }
  },
  computed: {
    videoUrls() {
      const videoUrls = []
      if (this.videoUrlMobile) videoUrls.push(this.videoUrlMobile)
      if (this.videoUrlDesktop) videoUrls.push(this.videoUrlDesktop)
      return videoUrls
    },
    imageSources () {
      const images = []
      if (this.imageMobile) images.push(this.imageMobile)
      if (this.imageDesktop) images.push(this.imageDesktop)
      return images
    },
    notEmptyClaims() {
      return this.items.filter(
        ({ title, description, image }) =>
          !isEmpty(title) && !isEmpty(description) && !isEmpty(image)
      )
    }
  },
  methods: {
    isEmpty
  }
})